import { Component } from '@theme/component';
import { onDocumentLoaded, calculateHeaderGroupHeight, setHeaderAdvancedLayoutOffset } from '@theme/utilities';

/**
 * Manages the Header Advanced floating bar and keeps header height CSS variables in sync.
 */
class HeaderAdvancedComponent extends Component {
  /** @type {ResizeObserver} */
  #resizeObserver = new ResizeObserver(() => {
    this.#updateHeights();
  });

  connectedCallback() {
    super.connectedCallback();
    this.#resizeObserver.observe(this);
    this.#updateHeights();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#resizeObserver.disconnect();
    document.body.style.removeProperty('--header-advanced-layout-offset');
  }

  #updateHeights() {
    const height = Math.round(this.getBoundingClientRect().height);
    document.body.style.setProperty('--header-advanced-height', `${height}px`);
    document.body.style.setProperty('--header-height', `${height}px`);
    setHeaderAdvancedLayoutOffset(this);

    const headerGroup = document.querySelector('#header-group');
    if (headerGroup instanceof HTMLElement) {
      const headerGroupHeight = calculateHeaderGroupHeight(this, headerGroup);
      document.body.style.setProperty('--header-group-height', `${headerGroupHeight}px`);
    }
  }
}

if (!customElements.get('header-advanced-component')) {
  customElements.define('header-advanced-component', HeaderAdvancedComponent);
}

onDocumentLoaded(() => {
  const headerAdvanced = document.querySelector('#header-advanced-component');
  const headerGroup = document.querySelector('#header-group');

  if (!(headerAdvanced instanceof HTMLElement) || !(headerGroup instanceof HTMLElement)) return;

  const syncLayoutOffset = () => setHeaderAdvancedLayoutOffset(headerAdvanced);

  const resizeObserver = new ResizeObserver(() => {
    const height = Math.round(headerAdvanced.getBoundingClientRect().height);
    document.body.style.setProperty('--header-advanced-height', `${height}px`);
    document.body.style.setProperty('--header-height', `${height}px`);
    syncLayoutOffset();
    document.body.style.setProperty(
      '--header-group-height',
      `${calculateHeaderGroupHeight(headerAdvanced, headerGroup)}px`
    );
  });

  resizeObserver.observe(headerAdvanced);
  window.addEventListener('resize', syncLayoutOffset);

  for (const child of headerGroup.children) {
    if (child instanceof HTMLElement && child !== headerAdvanced.closest('.shopify-section')) {
      resizeObserver.observe(child);
    }
  }
});
